module.exports = __webpack_public_path__ + "static/img/slide-3.bff7de4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-3.svg
// module id = 7rlA
// module chunks = 1